import CargaConcretoSchema from '@/schema/CargaConcretoSchema.schema'
import {ID, Resource, TAG} from 'simpli-web-sdk'

export class CargaConcreto extends Resource {
  idCargaConcretoPk: number | null = null
  idCargaFk: number | null = null
  descricaoProduto: string | null = null
  horarioChegadaObra: string | null = null
  horarioInicioDescarga: string | null = null
  horarioTerminoDescarga: string | null = null
  adicaoAgua: number | null = null
  retornoConcreto: number | null = null
  horarioSaidaObra: string | null = null
  horarioChegadaCentral: string | null = null
  hodometroInicial: number | null = null
  hodometroFinal: number | null = null
    contrato: string | null = null
  usina: string | null = null

  readonly $name: string = 'CargaConcreto'

  readonly $endpoint: string = ''

  get $schema() {
    return CargaConcretoSchema(this)
  }

  get $id() {
    /* TODO: define the ID */
    return 0
  }
  set $id(val: ID) {
    /* TODO: define the ID */
  }

  get $tag() {
    return this.$tag
  }
  set $tag(val: TAG) {
    this.$tag = val
  }
}
